import { render, staticRenderFns } from "./create-asset-dialog.vue?vue&type=template&id=8cd07020&scoped=true&"
import script from "./create-asset-dialog.vue?vue&type=script&lang=js&"
export * from "./create-asset-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd07020",
  null
  
)

export default component.exports